<script setup lang="ts">
import { defineProps, defineEmits, ref, withDefaults } from "vue";

withDefaults(
  defineProps<{
    label: string;
    items: [];
    selectedItem: object | string | undefined;
    isDropdownOpen: boolean;
    borderColor?: string;
    labelWidthClass?: string;
  }>(),
  {
    borderColor: "border-divider",
    labelWidthClass: "font-semibold",
  }
);

const emit = defineEmits<{
  (e: "toggle"): void;
}>();

const triggerRef = ref<HTMLElement | null>(null);
const dropdownRef = ref<HTMLElement | null>(null);

function toggle() {
  emit("toggle");
}
</script>

<template>
  <div class="text-left w-full flex flex-col gap-2 sf-pro">
    <label
      class="text-brown text-base leading-[20px] select-none"
      :class="labelWidthClass"
    >
      {{ label }}
    </label>
    <div class="relative">
      <button
        ref="triggerRef"
        type="button"
        class="w-full h-[52px] rounded-[14px] border focus:outline-none"
        :class="{
          ...borderColor,
          'opacity-40 pointer-events-none': selectedItem === undefined,
        }"
        @click="toggle"
      >
        <slot name="selectedItem" :item="selectedItem">
          {{ selectedItem }}
        </slot>
      </button>

      <div
        v-if="isDropdownOpen && items.length > 0"
        ref="dropdownRef"
        class="absolute w-full rounded-[14px] border border-divider focus:outline-none right-0 z-10 mt-2 bg-white overflow-hidden"
      >
        <div v-for="item in items" :key="item.id">
          <slot name="dropdownItem" :item="item">
            {{ item }}
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
